<div *ngIf="meeting"
     class="meeting"
     [class.mobile]="deviceService.isMobile()">
  <div class="toolbar" *ngIf="isBrowser">
    <div class="copy-informer" [class.active]="state.copied"><span>{{'invite-card.link-copied' | translate}}</span></div>
    <div class="tools-box">
    <app-bookmark [item]="meeting"></app-bookmark>
    <on-ui-card-menu>
      <a class="menu-item warn" *ngIf="meeting.purl" [href]="meeting.purl">[⚠️] Panel [meeting]</a>
      <a class="menu-item warn" *ngIf="meeting.user_service?.purl" [href]="meeting.user_service?.purl">[⚠️] Panel [service]</a>
      <a class="menu-item warn" *ngIf="meeting.user_service_contract?.purl" [href]="meeting.user_service_contract?.purl">[⚠️] Panel [contract]</a>
      <div *ngIf="debug$ | async" class="menu-item" (click)="printMeetingInfo()">[DEBUG]</div>
      <div class="menu-item"
            *ngIf="can('edit')"
            (click)="openMeetingFormModal()">{{ 'meetings.menu-edit' | translate }}</div>
      <div class="menu-item"
           *ngIf="can('reschedule')"
           (click)="onReschedule()">{{ 'meetings.menu-reschedule' | translate }}</div>
      <div class="menu-item"
           *ngIf="state.subscribed"
           (click)="unsubscribe()">{{ 'user-profile.menu-unsubscribe' | translate }}</div>
      <div class="menu-item" #shareLinkRef>
        <button type="button"
                [ngxClipboard]
                [cbContent]="meetingUrl"
                (cbOnSuccess)="onCopied($event)"
                [container]="shareLinkRef">{{ 'meetings.menu-share' | translate }}<!-- Поделиться --></button>
      </div>
      <div class="menu-item"
           *ngIf="can('invite')"
           (click)="openInviteModal()">{{ 'meetings.menu-invite' | translate }}<!--Пригласить--></div>
      <div class="menu-item warn"
           *ngIf="can('leave') || can('leaveWithPenalty')"
           (click)="leaveMeeting()">{{ 'meetings.menu-leave-meeting' | translate }}<!--Покинуть--></div>
      <div class="menu-item warn"
           *ngIf="can('cancel') || can('cancelWithPenalty')"
           (click)="cancelMeeting()">{{ 'meetings.menu-cancel-meeting' | translate }}<!--Отменить--></div>
      <div class="menu-item"
           *ngIf="false"><a href="#">{{ 'meetings.menu-complain' | translate }}<!--Пожаловаться--></a></div>
    </on-ui-card-menu>
    </div>
  </div>

  <div class="meta">
    <div class="cover-wrap">
      <on-ui-cover [cover]="cover" [attr.data-test]="'coverImg'"></on-ui-cover>
      <div class="type" [ngClass]="meetingTypeEnum[meeting.type]">{{ typeLabel(meeting.type) | translate }}</div>
    </div>
    <div class="details">
      <span *ngIf="false" class="category"></span>
      <span class="subject">{{ subject }}</span>
      <h3 class="title"><app-meeting-title [routerLink]="meetingJoinRoute" [meeting]="meeting"></app-meeting-title></h3>
      <ng-container *ngIf="!deviceService.isMobile()">
        <ng-container *ngTemplateOutlet="relatedInfo"></ng-container>
        <ng-container *ngTemplateOutlet="teacherBlock"></ng-container>
      </ng-container>
    </div>
  </div>

  <ng-container *ngIf="deviceService.isMobile()">
    <ng-container *ngTemplateOutlet="relatedInfo"></ng-container>
    <ng-container *ngTemplateOutlet="teacherBlock"></ng-container>
  </ng-container>
  <p *ngIf="description" class="description">{{ description }}
    <span *ngIf="canCut" class="description more" (click)="toggleCut()">
      {{ (state.cut ? 'meetings.read-more' : 'meetings.read-hide') | translate }}
    </span>
  </p>
  <div class="bottom-block">
    <div class="price-wrap">
      <ng-template [ngIf]="isPaidMeeting">
        <span class="price">{{ priceFormatted }}</span>
        <span class="period">{{ 'news.teacher-card.price' | translate }}</span>
      </ng-template>
    </div>
    <div class="action-wrap">
      <ng-template [ngIf]="isGuest" [ngIfElse]="altCase3Ref">
        <div *ngIf="can('authJoin')" class="btn btn-signup"
             (click)="authorize()">
          <on-ui-button class="primary"
                        label="meetings.join-action">
          </on-ui-button>
        </div>
        <div *ngIf="can('authPaidJoin')" class="btn btn-open"
             (click)="authorize()">
          <on-ui-button class="secondary"
                        label="meetings.paid-join-action">
          </on-ui-button>
        </div>
      </ng-template>
      <ng-template #altCase3Ref>
        <ng-template [ngIf]="meeting?.is?.participantLimit" [ngIfElse]="altCase4Ref">
          <on-ui-button class="status"
                        label="meetings.join.no-more-places-to-join">
          </on-ui-button>
        </ng-template>
        <ng-template #altCase4Ref>
          <a *ngIf="can('join')"
             [routerLink]="meetingJoinRoute"
             [queryParams]="{ join: 'auto' }">
            <on-ui-button class="primary"
                          label="meetings.join-action">
            </on-ui-button>
          </a>
          <a *ngIf="can('paidJoin')"
             [routerLink]="meetingJoinRoute"
             [queryParams]="{ join: 'auto' }">
            <on-ui-button class="secondary"
                          label="meetings.paid-join-action">
            </on-ui-button>
          </a>
          <a *ngIf="can('acceptInvitation')"
             [routerLink]="meetingJoinRoute"
             [queryParams]="{ accept: 'auto' }">
            <on-ui-button class="primary"
                          label="meetings.join.accept-meeting">
            </on-ui-button>
          </a>
          <a *ngIf="can('paidAcceptInvitation')"
             [routerLink]="meetingJoinRoute"
             [queryParams]="{ accept: 'auto' }">
            <on-ui-button class="primary"
                          label="meetings.join.accept-paid-meeting">
            </on-ui-button>
          </a>
          <a *ngIf="can('open')"
             target="_blank"
             [routerLink]="meetingJoinRoute"
             [queryParams]="{ open: 'auto' }">
            <on-ui-button class="primary"
                          label="meetings.open-action">
            </on-ui-button>
          </a>
          <ng-template [ngIf]="meeting.user_service_contract?.can?.setup_payments && meeting.user_service_contract?.visit_info?.unpaid_order">
            <on-ui-button
              *ngIf="meeting.user_service_contract?.is?.accepting"
              class="secondary signup-button"
              (onclick)="openPaymentForm()"
              label="dashboard.label-btn.accept-and-pay">
            </on-ui-button>

            <on-ui-button
              *ngIf="meeting.user_service_contract?.is?.suspended"
              class="secondary renew-button"
              (onclick)="openPaymentForm()"
              label="library.user-service-card.renew_subscription">
            </on-ui-button>
          </ng-template>
        </ng-template>
      </ng-template>
    </div>
  </div>
</div>

<ng-template #ratingWrap>
  <app-rating [stats]="authorStats"></app-rating>
</ng-template>

<ng-template #teacherBlock>
  <app-author-info [user]="author"></app-author-info>
</ng-template>

<ng-template #relatedInfo>
<div class="related-info">
  <span class="related-info-item">{{ typeLabel(meeting.type) | translate }}</span>
  <div class="related-info-separator"></div>
  <span class="related-info-item">{{ meetingBeginAt | zonedDate: me?.timezone | dfnsFormat: 'dd MMM' }}</span>
  <div class="related-info-separator"></div>
  <span *ngIf="meetingBeginAt && meetingEndAt" class="related-info-item">
    {{ meetingBeginAt | zonedDate: me?.timezone | dfnsFormat: 'HH:mm' }}
  </span>
  <div class="related-info-separator"></div>
  <span class="related-info-item">
    {{ differenceInMinutes(meetingEndAt, meetingBeginAt) }} {{ 'library.user-service-card.min' | translate }}
  </span>
</div>
</ng-template>

<app-modal *ngIf="deviceService.isDesktop() && state.inviteModal" [schedule]="true" [canClose]="false"
           (closed)="closeInviteModal()">
  <app-modal-body>
    <app-invite-to-meeting [meeting]="meeting"></app-invite-to-meeting>
  </app-modal-body>
</app-modal>

<app-mobile-modal *ngIf="!deviceService.isDesktop() && state.inviteModal" (closed)="closeInviteModal()">
  <app-mobile-modal-title>{{ 'classrooms.invite.title' | translate }}</app-mobile-modal-title>
  <app-mobile-modal-body>
    <app-invite-to-meeting [meeting]="meeting"></app-invite-to-meeting>
  </app-mobile-modal-body>
</app-mobile-modal>

<ng-template [ngIf]="state.meetingFormModal">
  <app-modal *ngIf="deviceService.isDesktop(); else mobileMeetingForm"
             [canClose]="false"
             (closed)="closeMeetingFormModal()">
    <app-modal-body>
      <app-meeting-form-wrapper [meetingId]="meeting.id"
                                (saved)="onMeetingSaved()"
                                [caller]="'app-meeting-card'">
      </app-meeting-form-wrapper>
    </app-modal-body>
  </app-modal>

  <ng-template #mobileMeetingForm>
    <app-mobile-modal (closed)="closeMeetingFormModal()">
      <app-mobile-modal-title>{{ 'lingo2-forms.meetings.form-title' | translate }}</app-mobile-modal-title>
      <app-mobile-modal-body>
        <app-meeting-form-wrapper [meetingId]="meeting.id"
                                  (saved)="onMeetingSaved()"
                                  [caller]="'app-meeting-card'">
        </app-meeting-form-wrapper>
      </app-mobile-modal-body>
    </app-mobile-modal>
  </ng-template>
</ng-template>

<app-user-service-contract-checkout-dialog
  *ngIf="paymentFormVisible"
  [userServiceContractId]="meeting.user_service_contract?.id"
  (succeed)="onPaymentSucceed()"
  (closed)="closePaymentForm()"
></app-user-service-contract-checkout-dialog>

<app-alert *ngIf="state.confirmationAlert && state.confirmationOptions"
           [type]="state.confirmationOptions.type">
  <ng-container alert-title>{{state.confirmationOptions.title | translate}}</ng-container>
  <ng-container alert-body>{{state.confirmationOptions.description | translate}}</ng-container>
  <ng-container alert-buttons>
    <on-ui-button label="{{ state.confirmationOptions.close_button_text }}"
                  class="primary outline"
                  (onclick)="closeConfirmationAlert()">
    </on-ui-button>
    <on-ui-button label="{{ state.confirmationOptions.confirm_button_text }}"
                  class="primary"
                  (onclick)="confirm()">
    </on-ui-button>
  </ng-container>
</app-alert>
